/* Keep programmatic drawer focus accessible without showing keyboard rings
   after a touch/mouse activation (including Safari's focus-visible heuristic). */
(() => {
  const page = document.documentElement;
  const pointer = () => { page.dataset.grovaInput = 'pointer'; };
  window.addEventListener('pointerdown', pointer, { capture: true, passive: true });
  window.addEventListener('keydown', (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey || ['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) return;
    page.dataset.grovaInput = 'keyboard';
  }, { capture: true });
})();
